<template>
  <div
    class="wrapper"
    @mouseover="isHovered = true"
    @touchstart="isHovered = true"
    @mouseleave="isHovered = false"
    @touchend="isHovered = false"
  >
    <IconCity :color="isHovered ? '#F39A2D' : '#ADADAD'" />
    <span>{{ city }}</span>
  </div>
</template>
<script>
import IconCity from "@/components/icons/IconCity.vue";

export default {
  name: "CityItem",
  components: { IconCity },
  data() {
    return {
      isHovered: false,
    };
  },
  props: {
    city: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 8px;
  background-color: #f6f6f6;
  border: 1px solid #f6f6f6;
  border-radius: 8px;
  gap: 12px;
  cursor: pointer;

  &:hover {
    background-color: #fef6e8;
    border: 1px solid #fabb44;
  }
}

span {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}
</style>
